import { Step } from "../models/step";
import ApiService from "../services/api";

export const fetchSteps = async (): Promise<Step[]> => {
    const apiService = new ApiService();
    try {
        const response = await apiService.get<Step[]>('/occurrence/step');
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error('Erro ao buscar etapas');
        }
    } catch (error) {
        console.error('Error fetching steps:', error);
        throw error;
    }
};

export const updateStepElapsedHours = async (stepId: string, hoursElapsed: number): Promise<Step | undefined> => {
    const apiService = new ApiService();
    try {
        const response = await apiService.put(`/occurrence/step/${stepId}`, {
            hoursElapsed
        });
        if (response.status === 200) {
            return response.data as Step;
        } else {
            throw new Error('Erro ao atualizar etapa');
        }
    } catch (error) {
        console.error('Error updating step:', error);
        throw error;
    }
};
